import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first } from 'rxjs';
import saveAs from 'file-saver';
import { VendorMiArea } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';

@Component({
  selector: 'app-pond-consolidate-report',
  templateUrl: './pond-consolidate-report.component.html',
  styleUrls: ['./pond-consolidate-report.component.scss']
})
export class PondConsolidateReportComponent implements OnInit {

  consolidateData: any[];
  totalApp:any;
  totalArea:any;
  verifiedApp:any;
  verifiedAppArea:any;
  pendingApp:any;
  incompleteApp:any;
  incompleteAppArea:any;
  rejectApp:any;
  intimation_Given_by_Farmer_Stage1:any;
  intimation_Area_Stage1:any;
  physical_Verification_Stage1:any;
  physical_Verification_Area_Stage1:any;
  applications_Processed_for_release_of_assistance_Stage1:any;
  subsidy_Assistance_Processed_Area_Stage1:any;
  subsidy_Assistance_Amount_Stage1:any;
  application_Processed_Lots_Stage1:any;
  subsidyDisbursed_Stage1:any;
  subsidy_Disbursed_Stage1_Area:any;
  subsidyDisbursedAmount_Stage1:any;
  intimation_Given_by_Farmer_Stage2:any;
  intimation_Area_Stage2:any;
  physical_Verification_Stage2:any;
  physical_Verification_Area_Stage2:any;
  applications_Processed_for_release_of_assistance_Stage2:any;
  subsidy_Assistance_Processed_Area_Stage2:any;
  subsidy_Assistance_Amount_Stage2:any;
  application_Processed_Lots_Stage2:any;
  application_Processed_Lots_Stage2_Area:any;
  subsidyDisbursed_Stage2:any;
  subsidy_Disbursed_Stage2_Area:any;
  subsidyDisbursedAmount_Stage2:any;
  applications_Processed_for_release_of_assistance_Stage3:any;
  subsidy_Assistance_Processed_Area_Stage3:any;
  subsidy_Assistance_Amount_Stage3:any;
  application_Processed_Lots_Stage3:any;
  application_Processed_Lots_Stage3_Area:any;
  subsidyDisbursed_Stage3:any;
  subsidy_Disbursed_Stage3_Area:any;
  subsidyDisbursedAmount_Stage3:any;
  Application_Processed_Lots_Stage1_Area:any;

  
  grandTotalApp:any;
  grandTotalArea:any;
  grandVerifiedApp:any;
  grandVerifiedAppArea:any;
  grandPendingApp:any;
  grandIncompleteApp:any;
  grandIncompleteAppArea:any;
  grandRejectApp:any;
  grandIntimation_Given_by_Farmer_Stage1:any;
  grandIntimation_Area_Stage1:any;
  grandPhysical_Verification_Stage1:any;
  grandPhysical_Verification_Area_Stage1:any;
  grandApplications_Processed_for_release_of_assistance_Stage1:any;
  grandSubsidy_Assistance_Processed_Area_Stage1:any;
  grandSubsidy_Assistance_Amount_Stage1:any;
  grandApplication_Processed_Lots_Stage1:any;
  grandSubsidyDisbursed_Stage1:any;
  grandSubsidy_Disbursed_Stage1_Area:any;
  grandSubsidyDisbursedAmount_Stage1:any;
  grandIntimation_Given_by_Farmer_Stage2:any;
  grandIntimation_Area_Stage2:any;
  grandPhysical_Verification_Stage2:any;
  grandPhysical_Verification_Area_Stage2:any;
  grandApplications_Processed_for_release_of_assistance_Stage2:any;
  grandSubsidy_Assistance_Processed_Area_Stage2:any;
  grandSubsidy_Assistance_Amount_Stage2:any;
  grandApplication_Processed_Lots_Stage2:any;
  grandApplication_Processed_Lots_Stage2_Area:any;
  grandSubsidyDisbursed_Stage2:any;
  grandSubsidy_Disbursed_Stage2_Area:any;
  grandSubsidyDisbursedAmount_Stage2:any;
  grandApplications_Processed_for_release_of_assistance_Stage3:any;
  grandSubsidy_Assistance_Processed_Area_Stage3:any;
  grandSubsidy_Assistance_Amount_Stage3:any;
  grandApplication_Processed_Lots_Stage3:any;
  grandApplication_Processed_Lots_Stage3_Area:any;
  grandSubsidyDisbursed_Stage3:any;
  grandSubsidy_Disbursed_Stage3_Area:any;
  grandSubsidyDisbursedAmount_Stage3:any;
  grandApplication_Processed_Lots_Stage1_Area:any;
  
  
  
  arrayIndex:number;
  tempConsolidateData: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: VendorMiArea[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  displayMaximizable:boolean;
  displayMaximizable_totalApp:boolean;
  displayMaximizable_pendingApp:boolean;
  drilldownDetails:any;
  pendingType:any;
  displayMaximizable_rejectedApp:any;
  vendorName:any;
  name:any;
  selectedYear:any
  financialYears:any[]=[]
  routePath:any;
  subjectSub:any;
  public subscriptions: any = [];
  public loading: boolean = false;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
  //   this.financialYears = [
  //     // {name: "2021-22", code: "2021-22"},
  //     {name: "2022-23", code: "2022-23"},
  //     // {name: "2023-24", code: "2023-24"},
  // ];
   
  this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
    (res) => {
        let router=this.router.url
  // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
      this.selectedYear=res
      this.loadData(this.selectedYear)
    }
        
);
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "Pond_Consolidate_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "Pond_Consolidate_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }
  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
   
    let sub=this.reportsService.getPondConsolidated_Report(this.selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.activityRecordService.activityRecord(this.userID, 'Vendor MI Area Report', '', new Date(), 'Success');
            // this.loader.close();
            this.loading = false;
            console.log("dataaa", data)
            if (data?.length > 0) {
              this.consolidateData = data;
              this.appVerificationModel = data;
              this.tempConsolidateData=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
              console.log(this.tempConsolidateData,"this.tempConsolidateData")
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.consolidateData=[]
              this.tempConsolidateData=[]
              this.calculateGrandTotal()
              // this.loader.close();
              this.loading = false;

            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Vendor MI Area Report', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
    
    
    
  }

  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        console.log(d)
        return {
          
          "District": d.District,
          "Block": d.Block,
          "Constituency": d.constituency,
          "total App": d.totalApp,
          "Total Area": d.TotalArea,
          "Verified App": d.VerifiedApp,
          "verified App Area": d.verifiedAppArea,
          "Pending App": d.PendingApp,
          "incomplete App Area": d.incompleteAppArea,
          "reject App": d.rejectApp,
          "Intimation given by farmer stage1": d.Intimation_Given_by_Farmer_Stage1,
          "Intimation Area(Stage1)": d.Intimation_Area_Stage1,
          "Physical Verification(Stage1)": d.Physical_Verification_Stage1,
          "Physical Verification Area(Stage1)": d.Physical_Verification_Area_Stage1,
          "App Processed for release of Assistance(Stage1)": d.Applications_Processed_for_release_of_assistance_Stage1,
          
          "Subsidy Assistance Processed Area (Stage1)": d.Subsidy_Assistance_Processed_Area_Stage1,
          "Subsidy Assistance Amount(Stage1)": d.Subsidy_Assistance_Amount_Stage1,
          "Appliaction Processed Lots(Stage1)": d.Application_Processed_Lots_Stage1,
          "Application Processed Lots Area(Stage1)": d.Application_Processed_Lots_Stage1_Area,
          "Subsidy Disbursed(Stage1)": d.SubsidyDisbursed_Stage1,
          "Subsidy Disbursed Area(Stage1)": d.Subsidy_Disbursed_Stage1_Area,
          "Subsidy Disbursed Amount(Stage1)": d.SubsidyDisbursedAmount_Stage1,
          "Intimation Given By Farmer(Stage2)": d.Intimation_Given_by_Farmer_Stage2,
          "Intimation Area(Stage2)": d.Intimation_Area_Stage2,
          "Physical Verf (Stage2)": d.Physical_Verification_Stage2,
          "Physical Verification Area(Stage2)": d.Physical_Verification_Area_Stage2,
          "Application Processed for release of Assistance (Stage2)": d.Applications_Processed_for_release_of_assistance_Stage2,
          "Subsidy Assistance Processed Area(Stage2)": d.Subsidy_Assistance_Processed_Area_Stage2,
          "Subsidy Assistance Amount(Stage2)": d.Subsidy_Assistance_Amount_Stage2,
          "Applications Processed Lots(Stage2)": d.Application_Processed_Lots_Stage2,
          "Applications Processed Lots Area(Stage2)": d.Application_Processed_Lots_Stage2_Area,
          "Subsidy Disbursed(Stage2)": d.SubsidyDisbursed_Stage2,
          "Subsidy Disbursed Area(Stage2)": d.Subsidy_Disbursed_Stage2_Area,
          "Subsidy Disbursed Amount (Stage2)": d.SubsidyDisbursedAmount_Stage2,
          "Application Processed for release of assistance(Stage3)": d.Applications_Processed_for_release_of_assistance_Stage3,
          "Subsidy Assistance Processed Area(Stage3)": d.Subsidy_Assistance_Processed_Area_Stage3,
          "Subsidy Assistance Amount(Stage3)": d.Subsidy_Assistance_Amount_Stage3,
          "Applications Processed Lots(Stage3)": d.Application_Processed_Lots_Stage3,
          "Applications Processed Lots Area(Stag3)": d.Application_Processed_Lots_Stage3_Area,
          "Subsidy Disbursed(Stage3)": d.SubsidyDisbursed_Stage3,
          "Subsidy Disbursed Area(Stage3)": d.Subsidy_Disbursed_Stage3_Area,
          "Subsidy Disbursed Amount(Stage3)": d.SubsidyDisbursedAmount_Stage3,
        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'District', header: 'District'},
      {field: 'Block', header: 'Target Area'},
      {field: 'Constituency', header: 'Constituency'},
      {field: 'totalApp', header: 'total App'},
      {field: 'TotalArea', header: 'Total Area'},
      {field: 'VerifiedApp', header: 'Verf App'},
      {field: 'verifiedAppArea', header: 'Verf App Area'},
      {field: 'PendingApp', header: 'Pending App'},
      {field: 'incompleteAppArea', header: 'incomplete App Area'},
      {field: 'rejectApp', header: 'reject App'},
      {field: 'Intimation_Given_by_Farmer_Stage1', header: 'Intimation given by farmer stage1'},
      {field: 'Intimation_Area_Stage1', header: 'Intimation Area(Stage1)'},
      {field: 'Physical_Verification_Stage1', header: 'Phy Verf(Stage1)'},
      {field: 'Physical_Verification_Area_Stage1', header: 'Phy Verf Area(Stage1)'},
      {field: 'Applications_Processed_for_release_of_assistance_Stage1', header: 'App Processed for release of Assistance(Stage1)'},
      {field: 'Subsidy_Assistance_Processed_Area_Stage1', header: 'Subsidy Assistance Processed Area (Stage1)'},
      {field: 'Subsidy_Assistance_Amount_Stage1', header: 'Subsidy Assistance Amount(Stage1)'},
      {field: 'Application_Processed_Lots_Stage1', header: 'App Processed Lots(Stage1)'},
      {field: 'Application_Processed_Lots_Stage1_Area', header: 'App Processed Lots Area(Stage1)'},
      {field: 'SubsidyDisbursed_Stage1', header: 'Subsidy Disbursed(Stage1)'},
      {field: 'Subsidy_Disbursed_Stage1_Area', header: 'Subsidy Disbursed Area(Stage1)'},
      {field: 'SubsidyDisbursedAmount_Stage1', header: 'Subsidy Disbursed Amt(Stage1)'},
      {field: 'Intimation_Given_by_Farmer_Stage2', header: 'Intimation Given By Farmer(Stage2)'},
      {field: 'Intimation_Area_Stage2', header: 'Intimation Area(Stage2)'},
      {field: 'Physical_Verification_Stage2', header: 'Phy Verf (Stage2)'},
      {field: 'Physical_Verification_Area_Stage2', header: 'Phy Verf Area(Stage2)'},
      {field: 'Applications_Processed_for_release_of_assistance_Stage2', header: 'App Processed for release of Assistance (Stage2)'},
      {field: 'Subsidy_Assistance_Processed_Area_Stage2', header: 'Subsidy Assistance Processed Area(Stage2)'},
      {field: 'Subsidy_Assistance_Amount_Stage2', header: 'Subsidy Assistance Amt(Stage2)'},
      {field: 'Application_Processed_Lots_Stage2', header: 'App Processed Lots(Stage2)'},
      {field: 'Application_Processed_Lots_Stage2_Area', header: 'App Processed Lots Area(Stage2)'},
      {field: 'SubsidyDisbursed_Stage2', header: 'Subsidy Disbursed(Stage2)'},
      {field: 'Subsidy_Disbursed_Stage2_Area', header: 'Subsidy Disbursed Area(Stage2)'},
      {field: 'SubsidyDisbursedAmount_Stage2', header: 'Subsidy Disbursed Amt (Stage2)'},
      {field: 'Applications_Processed_for_release_of_assistance_Stage3', header: 'App Processed for release of assistance(Stage3)'},
      {field: 'Subsidy_Assistance_Processed_Area_Stage3', header: 'Subsidy Assistance Processed Area(Stage3)'},
      {field: 'Subsidy_Assistance_Amount_Stage3', header: 'Subsidy Assistance Amt(Stage3)'},
      {field: 'Application_Processed_Lots_Stage3', header: 'App Processed Lots(Stage3)'},
      {field: 'Application_Processed_Lots_Stage3_Area', header: 'App Processed Lots Area(Stag3)'},
      {field: 'SubsidyDisbursed_Stage3', header: 'Subsidy Disbursed(Stage3)'},
      {field: 'Subsidy_Disbursed_Stage3_Area', header: 'Subsidy Disbursed Area(Stage3)'},
      {field: 'SubsidyDisbursedAmount_Stage3', header: 'Subsidy Disbursed Amt(Stage3)'},
     
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default({orientation: 'landscape'});
        doc.autoTable(this.exportColumns, modelData,{styles: {fontSize: 2 }});
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempConsolidateData=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.totalApp=0;
        this.totalArea=0;
        this.incompleteAppArea=0;
        this.verifiedApp=0;
        this.verifiedAppArea=0;
        this.pendingApp=0;
        this.incompleteApp=0;
        this.incompleteAppArea=0;
        this.rejectApp=0;
        this.intimation_Given_by_Farmer_Stage1=0;
        this.intimation_Area_Stage1=0;
        this.physical_Verification_Stage1=0;
        this.physical_Verification_Area_Stage1=0;
        this.applications_Processed_for_release_of_assistance_Stage1=0;
        this.subsidy_Assistance_Processed_Area_Stage1=0;
        this.subsidy_Assistance_Amount_Stage1=0;
        this.application_Processed_Lots_Stage1=0;
        this.subsidyDisbursed_Stage1=0;
        this.subsidy_Disbursed_Stage1_Area=0;
        this.subsidyDisbursedAmount_Stage1=0;
        this.intimation_Given_by_Farmer_Stage2=0;
        this.intimation_Area_Stage2=0;
        this.physical_Verification_Stage2=0;
        this.physical_Verification_Area_Stage2=0;
        this.applications_Processed_for_release_of_assistance_Stage2=0;
        this.subsidy_Assistance_Processed_Area_Stage2=0;
        this.subsidy_Assistance_Amount_Stage2=0;
        this.application_Processed_Lots_Stage2=0;
        this.application_Processed_Lots_Stage2_Area=0;
        this.subsidyDisbursed_Stage2=0;
        this.subsidy_Disbursed_Stage2_Area=0;
        this.subsidyDisbursedAmount_Stage2=0;
        this.applications_Processed_for_release_of_assistance_Stage3=0;
        this.subsidy_Assistance_Processed_Area_Stage3=0;
        this.subsidy_Assistance_Amount_Stage3=0;
        this.application_Processed_Lots_Stage3=0;
        this.application_Processed_Lots_Stage3_Area=0;
        this.subsidyDisbursed_Stage3=0;
        this.subsidy_Disbursed_Stage3_Area=0;
        this.subsidyDisbursedAmount_Stage3=0;
        this.Application_Processed_Lots_Stage1_Area=0
        for(let i=this.arrayIndex ;this.tempConsolidateData.length>10?i<this.arrayIndex+10:i<this.tempConsolidateData.length;i++) {
          //console.log( this.totalApp,"totalAPPPPPPPPP")
          this.totalApp +=this.tempConsolidateData[i].totalApp;
          this.totalArea +=this.tempConsolidateData[i].TotalArea;
          this.verifiedApp +=this.tempConsolidateData[i].VerifiedApp;
          this.verifiedAppArea +=this.tempConsolidateData[i].verifiedAppArea;
          this.pendingApp +=this.tempConsolidateData[i].PendingApp;
          this.incompleteApp +=this.tempConsolidateData[i].IncompleteApp;
          this.incompleteAppArea +=this.tempConsolidateData[i].incompleteAppArea;
          this.rejectApp +=this.tempConsolidateData[i].rejectApp;
          this.intimation_Given_by_Farmer_Stage1 +=this.tempConsolidateData[i].Intimation_Given_by_Farmer_Stage1;
          this.intimation_Area_Stage1 +=this.tempConsolidateData[i].Intimation_Area_Stage1;
          this.physical_Verification_Stage1 +=this.tempConsolidateData[i].Physical_Verification_Stage1;
          this.physical_Verification_Area_Stage1 +=this.tempConsolidateData[i].Physical_Verification_Area_Stage1;
          this.applications_Processed_for_release_of_assistance_Stage1 +=this.tempConsolidateData[i].Applications_Processed_for_release_of_assistance_Stage1;
          this.subsidy_Assistance_Processed_Area_Stage1 +=this.tempConsolidateData[i].Subsidy_Assistance_Processed_Area_Stage1;
          this.subsidy_Assistance_Amount_Stage1 +=this.tempConsolidateData[i].Subsidy_Assistance_Amount_Stage1;
          this.application_Processed_Lots_Stage1 +=this.tempConsolidateData[i].Application_Processed_Lots_Stage1;
          this.subsidyDisbursed_Stage1 +=this.tempConsolidateData[i].SubsidyDisbursed_Stage1;
          this.subsidy_Disbursed_Stage1_Area +=this.tempConsolidateData[i].Subsidy_Disbursed_Stage1_Area;
          this.subsidyDisbursedAmount_Stage1 +=this.tempConsolidateData[i].SubsidyDisbursedAmount_Stage1;
          this.intimation_Given_by_Farmer_Stage2 +=this.tempConsolidateData[i].Intimation_Given_by_Farmer_Stage2;
          this.intimation_Area_Stage2 +=this.tempConsolidateData[i].Intimation_Area_Stage2;
          this.physical_Verification_Stage2 +=this.tempConsolidateData[i].Physical_Verification_Stage2;
          this.physical_Verification_Area_Stage2 +=this.tempConsolidateData[i].Physical_Verification_Area_Stage2;
          this.applications_Processed_for_release_of_assistance_Stage2 +=this.tempConsolidateData[i].Applications_Processed_for_release_of_assistance_Stage2;
          this.subsidy_Assistance_Processed_Area_Stage2 +=this.tempConsolidateData[i].Subsidy_Assistance_Processed_Area_Stage2;
          this.subsidy_Assistance_Amount_Stage2 +=this.tempConsolidateData[i].Subsidy_Assistance_Amount_Stage2;
          this.application_Processed_Lots_Stage2 +=this.tempConsolidateData[i].Application_Processed_Lots_Stage2;
          this.application_Processed_Lots_Stage2_Area +=this.tempConsolidateData[i].Application_Processed_Lots_Stage2_Area;
          this.subsidyDisbursed_Stage2 +=this.tempConsolidateData[i].SubsidyDisbursed_Stage2;
          this.subsidy_Disbursed_Stage2_Area +=this.tempConsolidateData[i].Subsidy_Disbursed_Stage2_Area;
          this.subsidyDisbursedAmount_Stage2 +=this.tempConsolidateData[i].SubsidyDisbursedAmount_Stage2;
          this.applications_Processed_for_release_of_assistance_Stage3 +=this.tempConsolidateData[i].Applications_Processed_for_release_of_assistance_Stage3;
          this.subsidy_Assistance_Processed_Area_Stage3 +=this.tempConsolidateData[i].Subsidy_Assistance_Processed_Area_Stage3;
          this.subsidy_Assistance_Amount_Stage3 +=this.tempConsolidateData[i].Subsidy_Assistance_Amount_Stage3;
          this.application_Processed_Lots_Stage3 +=this.tempConsolidateData[i].Application_Processed_Lots_Stage3;
          this.application_Processed_Lots_Stage3_Area +=this.tempConsolidateData[i].Application_Processed_Lots_Stage3_Area;
          this.subsidyDisbursed_Stage3 +=this.tempConsolidateData[i].SubsidyDisbursed_Stage3;
          this.subsidy_Disbursed_Stage3_Area +=this.tempConsolidateData[i].Subsidy_Disbursed_Stage3_Area;
          this.subsidyDisbursedAmount_Stage3 +=this.tempConsolidateData[i].SubsidyDisbursedAmount_Stage3;
          this.Application_Processed_Lots_Stage1_Area+=this.tempConsolidateData[i].Application_Processed_Lots_Stage1_Area;

        }
        // this.verfAppArea= this.verfAppArea.toFixed(4);
    

    }
    calculateGrandTotal(){
      this.grandTotalApp=0;
        this.grandTotalArea=0;
        this.grandVerifiedApp=0;
        this.grandVerifiedAppArea=0;
        this.grandPendingApp=0;
        this.grandIncompleteApp=0;
        this.grandIncompleteAppArea=0;
        this.grandRejectApp=0;
        this.grandIntimation_Given_by_Farmer_Stage1=0;
        this.grandIntimation_Area_Stage1=0;
        this.grandPhysical_Verification_Stage1=0;
        this.grandPhysical_Verification_Area_Stage1=0;
        this.grandApplications_Processed_for_release_of_assistance_Stage1=0;
        this.grandSubsidy_Assistance_Processed_Area_Stage1=0;
        this.grandSubsidy_Assistance_Amount_Stage1=0;
        this.grandApplication_Processed_Lots_Stage1=0;
        this.grandSubsidyDisbursed_Stage1=0;
        this.grandSubsidy_Disbursed_Stage1_Area=0;
        this.grandSubsidyDisbursedAmount_Stage1=0;
        this.grandIntimation_Given_by_Farmer_Stage2=0;
        this.grandIntimation_Area_Stage2=0;
        this.grandPhysical_Verification_Stage2=0;
        this.grandPhysical_Verification_Area_Stage2=0;
        this.grandApplications_Processed_for_release_of_assistance_Stage2=0;
        this.grandSubsidy_Assistance_Processed_Area_Stage2=0;
        this.grandSubsidy_Assistance_Amount_Stage2=0;
        this.grandApplication_Processed_Lots_Stage2=0;
        this.grandApplication_Processed_Lots_Stage2_Area=0;
        this.grandSubsidyDisbursed_Stage2=0;
        this.grandSubsidy_Disbursed_Stage2_Area=0;
        this.grandSubsidyDisbursedAmount_Stage2=0;
        this.grandApplications_Processed_for_release_of_assistance_Stage3=0;
        this.grandSubsidy_Assistance_Processed_Area_Stage3=0;
        this.grandSubsidy_Assistance_Amount_Stage3=0;
        this.grandApplication_Processed_Lots_Stage3=0;
        this.grandApplication_Processed_Lots_Stage3_Area=0;
        this.grandSubsidyDisbursed_Stage3=0;
        this.grandSubsidy_Disbursed_Stage3_Area=0;
        this.grandSubsidyDisbursedAmount_Stage3=0;
        this.grandApplication_Processed_Lots_Stage1_Area=0
        for(let vendorData of this.tempConsolidateData) {
          this.grandTotalApp +=vendorData.totalApp;
          this.grandTotalArea +=vendorData.TotalArea;
          this.grandVerifiedApp +=vendorData.VerifiedApp;
          this.grandVerifiedAppArea +=vendorData.verifiedAppArea;
          this.grandPendingApp +=vendorData.PendingApp;
          this.grandIncompleteApp +=vendorData.IncompleteApp;
          this.grandIncompleteAppArea +=vendorData.incompleteAppArea;
          this.grandRejectApp +=vendorData.rejectApp;
          this.grandIntimation_Given_by_Farmer_Stage1 +=vendorData.Intimation_Given_by_Farmer_Stage1;
          this.grandIntimation_Area_Stage1 +=vendorData.Intimation_Area_Stage1;
          this.grandPhysical_Verification_Stage1 +=vendorData.Physical_Verification_Stage1;
          this.grandPhysical_Verification_Area_Stage1 +=vendorData.Physical_Verification_Area_Stage1;
          this.grandApplications_Processed_for_release_of_assistance_Stage1 +=vendorData.Applications_Processed_for_release_of_assistance_Stage1;
          this.grandSubsidy_Assistance_Processed_Area_Stage1 +=vendorData.Subsidy_Assistance_Processed_Area_Stage1;
          this.grandSubsidy_Assistance_Amount_Stage1 +=vendorData.Subsidy_Assistance_Amount_Stage1;
          this.grandApplication_Processed_Lots_Stage1 +=vendorData.Application_Processed_Lots_Stage1;
          this.grandSubsidyDisbursed_Stage1 +=vendorData.SubsidyDisbursed_Stage1;
          this.grandSubsidy_Disbursed_Stage1_Area +=vendorData.Subsidy_Disbursed_Stage1_Area;
          this.grandSubsidyDisbursedAmount_Stage1 +=vendorData.SubsidyDisbursedAmount_Stage1;
          this.grandIntimation_Given_by_Farmer_Stage2 +=vendorData.Intimation_Given_by_Farmer_Stage2;
          this.grandIntimation_Area_Stage2 +=vendorData.Intimation_Area_Stage2;
          this.grandPhysical_Verification_Stage2 +=vendorData.Physical_Verification_Stage2;
          this.grandPhysical_Verification_Area_Stage2 +=vendorData.Physical_Verification_Area_Stage2;
          this.grandApplications_Processed_for_release_of_assistance_Stage2 +=vendorData.Applications_Processed_for_release_of_assistance_Stage2;
          this.grandSubsidy_Assistance_Processed_Area_Stage2 +=vendorData.Subsidy_Assistance_Processed_Area_Stage2;
          this.grandSubsidy_Assistance_Amount_Stage2 +=vendorData.Subsidy_Assistance_Amount_Stage2;
          this.grandApplication_Processed_Lots_Stage2 +=vendorData.Application_Processed_Lots_Stage2;
          this.grandApplication_Processed_Lots_Stage2_Area +=vendorData.Application_Processed_Lots_Stage2_Area;
          this.grandSubsidyDisbursed_Stage2 +=vendorData.SubsidyDisbursed_Stage2;
          this.grandSubsidy_Disbursed_Stage2_Area +=vendorData.Subsidy_Disbursed_Stage2_Area;
          this.grandSubsidyDisbursedAmount_Stage2 +=vendorData.SubsidyDisbursedAmount_Stage2;
          this.grandApplications_Processed_for_release_of_assistance_Stage3 +=vendorData.Applications_Processed_for_release_of_assistance_Stage3;
          this.grandSubsidy_Assistance_Processed_Area_Stage3 +=vendorData.Subsidy_Assistance_Processed_Area_Stage3;
          this.grandSubsidy_Assistance_Amount_Stage3 +=vendorData.Subsidy_Assistance_Amount_Stage3;
          this.grandApplication_Processed_Lots_Stage3 +=vendorData.Application_Processed_Lots_Stage3;
          this.grandApplication_Processed_Lots_Stage3_Area +=vendorData.Application_Processed_Lots_Stage3_Area;
          this.grandSubsidyDisbursed_Stage3 +=vendorData.SubsidyDisbursed_Stage3;
          this.grandSubsidy_Disbursed_Stage3_Area +=vendorData.Subsidy_Disbursed_Stage3_Area;
          this.grandSubsidyDisbursedAmount_Stage3 +=vendorData.SubsidyDisbursedAmount_Stage3;
          this.grandSubsidyDisbursedAmount_Stage3+=vendorData.Application_Processed_Lots_Stage1_Area;
    }
    }
    // financialYearChange(event:any){
    //   console.log(event,"eventeventeventevent")
    //   console.log(this.selectedYear,"this.selectedYear")
    //   this.loadData()
    // }

}